import React from 'react';
import '../../Assets/Css/NewsandUpdate.css';
import poster1 from '../../Assets/Images/poster1.svg'
import nayanatara from '../../Assets/Images/nayanatara.png'

const newsData = [
    {
      id: 1,
      title: "MR.X - Teaser",
      date: "Feb 22, 2025",
      description: `Prince Pictures has officially unveiled the first-look poster for their upcoming espionage action thriller Mr. X, and the excitement is already building as they announced that the teaser for the film will be out today. The production company shared the poster with the caption, “The game begins. #MrX - Teaser from TODAY,” igniting anticipation for the thrilling ride the film promises.<br><br> 
      Directed by Manu Anand, best known for his successful debut with FIR, Mr. X brings together Arya and Gautham Karthik in pivotal roles. Arya takes the lead, bringing his signature intensity to the screen, while Gautham Karthik plays a crucial character in this high-octane espionage drama. With its tagline, "A Hero will rise and roar," the film promises action-packed sequences and a gripping storyline that will keep audiences on the edge of their seats.`,
      image: poster1,
    },
    {
      id: 2,
      title: "Mannangatti Since 1960 - Wrapped Up",
      date: "May 9, 2024",
      description: `The makers of Nayanthara's next film in Tamil, titled Mannangatti Since 1960, announced on Thursday that they had officially wrapped up shooting of the film. Written and directed by Dude Vicky, Mannangatti Since 1960 is backed by Prince Pictures. The film also stars Yogi Babu, Devadarshini, Gouri Kishan, and Narendra Prasath, among others.<br><br>
      Tamil-Malayalam actor Nayanthara is currently busy with several film projects, including Mannangatti Since 1960. After being announced last year, the production team behind this movie recently announced its official wrap-up, sharing the news online and marking the occasion with a celebratory cake cutting.`,
      image: nayanatara,
    },
];

const NewsandUpdate = () => {
    return (
        <div className="news-updates" id="news">
            <div className="news-title">News & Updates</div>
            {newsData.map((news) => (
                <div key={news.id} className="news-item">
                    <img src={news.image} alt={news.title} />
                    <div className="news-content">
                        <div className="news-header">
                            <div className="news-number">{news.id}</div>
                            <div>
                                <div className="news-title-text">{news.title}</div>
                                <div className="news-date">{news.date}</div>
                            </div>
                        </div>
                        <div className="news-description" dangerouslySetInnerHTML={{ __html: news.description }} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NewsandUpdate;